/**
 * navConfig — структура sidebar.
 * Соответствует меню в ARCHITECTURE.md / MASTER_BLUEPRINT.
 */
import {
  Files,
  Sparkles,
  Image as ImageIcon,
  Languages,
  Network,
  Calendar,
  User,
  Folder,
  CreditCard,
  Cog,
  HelpCircle,
  Send,
  FileText,
  ScrollText,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavItem {
  path: string;
  labelKey: string;
  icon: LucideIcon;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export const navSections: NavSection[] = [
  {
    title: 'files',
    items: [
      { path: '/files/upload',     labelKey: 'upload',     icon: Files },
      { path: '/files/transform',  labelKey: 'transform',  icon: FileText },
      { path: '/files/results',    labelKey: 'results',    icon: Folder },
    ],
  },
  {
    title: 'process',
    items: [
      { path: '/process/search',       labelKey: 'search',       icon: HelpCircle },
      { path: '/process/matching',     labelKey: 'matching',     icon: Network },
      { path: '/process/generation',   labelKey: 'generation',   icon: Sparkles },
      { path: '/process/media',        labelKey: 'media',        icon: ImageIcon },
      { path: '/process/translations', labelKey: 'translations', icon: Languages },
      { path: '/process/complex',      labelKey: 'complex',      icon: Cog },
    ],
  },
  {
    title: 'logs',
    items: [
      { path: '/logs', labelKey: 'logs', icon: ScrollText },
    ],
  },
  {
    title: 'autoposting',
    items: [
      { path: '/autoposting/social',   labelKey: 'social',   icon: Send },
      { path: '/autoposting/articles', labelKey: 'articles', icon: Calendar },
    ],
  },
  {
    title: 'settings',
    items: [
      { path: '/settings/profile',  labelKey: 'profile',  icon: User },
      { path: '/settings/projects', labelKey: 'projects', icon: Folder },
      { path: '/settings/billing',  labelKey: 'billing',  icon: CreditCard },
      { path: '/settings/system',   labelKey: 'system',   icon: Cog },
      { path: '/settings/tips',     labelKey: 'tips',     icon: HelpCircle },
    ],
  },
];
